/*
 * @Author: yanghailong
 * @Date: 2024-12-28 10:40:20
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-08 10:02:04
 */

import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help"
import Konva from "konva"

class BreakerElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, "breaker", x, y, {
      text: "断路器",
      port: true,
      ...attrs
    })

    this.state = null

    // 底座加载完成时调用
    this.onLoad(() => {
      // 断路器本身较小，不需要显示名称
      this.label.visible(false)
    })
  }


  addKeyShape(name, attrs) {
    this.keyShape = this._createDarthNode()
    this.g.add(this.keyShape)

    setTimeout(() => {
      this.executeLoadedHook(this.keyShape)
    })
  }

  _createDarthNode() {
    return new Konva.Rect({
      width: 14,
      height: 25,
      fill: "#F73046",
      stroke: "#F73046",
      x: 0,
      y: 0
    })
  }

  /**
   * 设置断路器状态
   * @param {number} state
   */
  setBreakerState(state) {
    this.state = state;
    if (state) {
      this.keyShape.setAttr("fill", "#F73046")
    } else {
      this.keyShape.setAttr("stroke", "#3BB74F")
      this.keyShape.setAttr("fill", rgba(0,0,0,0))
    }
  }
}

export { BreakerElement }
